import { useEffect } from 'react';

export const useDoctorSelect = ({
    selectedDoctorId,
    selectedBranchId,
    selectedServiceId,
    setBranchList,
    setServicesList,
    setSelectedBranchId,
    setSelectedServiceId,
    allDoctors,
    branches,
    allServices,
    selectedInfo,
}) => {
    // eslint-disable-next-line max-statements
    useEffect(() => {
        if (selectedDoctorId) {
            const doctor = allDoctors.find(({ doctorId }) => doctorId === selectedDoctorId);
            if (!doctor) {
                setBranchList(branches);
                setServicesList(allServices);
                setSelectedBranchId('');
                setSelectedServiceId('');
                return;
            }

            const filteredBranches = doctor?.worksAt
                ?.map(({ branchId }) => branches.find(b => b.id === branchId))
                ?.filter(Boolean) || [];

            const filteredServices = doctor?.worksAt
                ?.flatMap(({ serviceMappings }) => serviceMappings?.map(({ serviceId }) => serviceId))
                ?.filter((id, index, self) => self.indexOf(id) === index)
                ?.map(serviceId => allServices.find(service => service.id === serviceId))
                ?.filter(Boolean) || [];

            setBranchList(filteredBranches);
            setServicesList(filteredServices);

            if (filteredBranches.length === 1) {
                setSelectedBranchId(filteredBranches[0].id);
            }

            const shouldPreselect = !selectedServiceId || !filteredServices.some(s => s.id === selectedServiceId);
            if (shouldPreselect) {
                if (filteredServices.length === 1) {
                    setSelectedServiceId(filteredServices[0].id);
                } else if (doctor?.worksAt && selectedBranchId) {
                    const branchWorksAt = doctor.worksAt.find(w => w.branchId === selectedBranchId);
                    const defaultServiceId = branchWorksAt?.serviceMappings?.find(sm => sm.defaultService)?.serviceId;
                    if (defaultServiceId) {
                        const defaultService = filteredServices.find(s => s.id === defaultServiceId);
                        if (defaultService) {
                            setSelectedServiceId(defaultService.id);
                            return;
                        }
                    }
                    if (selectedServiceId && !filteredServices.some(s => s.id === selectedServiceId)) {
                        setSelectedServiceId('');
                    }
                }
            }

            if (filteredBranches.length > 1) {
                if (!selectedBranchId || !filteredBranches.some(branch => branch.id === selectedBranchId)) {
                    setSelectedBranchId('');
                }
            }
        } else if (!selectedInfo?.doctors) {
            setBranchList([]);
            setServicesList([]);
            setSelectedBranchId('');
            setSelectedServiceId('');
        }
    }, [ selectedDoctorId, allDoctors?.length, branches, allServices?.length ]);
};
